var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.hideList,
          expression: "hideList"
        }
      ],
      staticClass: "switch-address-wrapper __pointer",
      on: { click: _vm.toggleList }
    },
    [
      _c(
        "span",
        {
          staticClass: "list-title",
          class: {
            down: !_vm.isShowList || _vm.isHardware,
            up: _vm.isShowList,
            "not-allowed": _vm.notAllowed && !_vm.isHardware
          }
        },
        [_vm._v(_vm._s(_vm.showStr))]
      ),
      _vm._v(" "),
      _c(
        "ul",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShowList,
              expression: "isShowList"
            }
          ],
          staticClass: "list"
        },
        _vm._l(_vm.addrList, function(addrObj, index) {
          return _c(
            "li",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.address !== addrObj.address,
                  expression: "address !== addrObj.address"
                }
              ],
              key: index,
              staticClass: "item",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.setDefaultAddr(addrObj.address, index)
                }
              }
            },
            [
              _c("div", { staticClass: "name" }, [
                _vm._v(
                  _vm._s(
                    addrObj.name ||
                      "" + _vm.$t("addrName", { index: index + 1 })
                  )
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "switch-address" }, [
                _vm._v(_vm._s(addrObj.address))
              ])
            ]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }